import AvailabilityOptionsDialog, {
  type AvailabilityOptionsDialogProps as Props,
} from '@discover-components/availability/options/dialog';
import withHandleRegularBooking, {
  type WithRegularBookingProps,
} from '@/components/hocs/withRegularBooking';

export type AvailabilityOptionsDialogProps = Omit<Props, 'handleBooking' | 'isProcessing'> & {
  restaurant: Omit<WithRegularBookingProps['restaurant'], 'showBookingPriceLabel'>;
};

const AvailabilityOptionsDialogWithBooking = (props: AvailabilityOptionsDialogProps) =>
  withHandleRegularBooking(AvailabilityOptionsDialog)({
    ...props,
    restaurant: {
      ...props.restaurant,
      showBookingPriceLabel: false,
    },
  });

export default AvailabilityOptionsDialogWithBooking;
